import { render, staticRenderFns } from "./ChallengeHome.vue?vue&type=template&id=e545d8ee&scoped=true&"
import script from "./ChallengeHome.vue?vue&type=script&lang=js&"
export * from "./ChallengeHome.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeHome.vue?vue&type=style&index=0&id=e545d8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e545d8ee",
  null
  
)

export default component.exports